var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3914 17.7162C32.4015 17.7162 40.5162 25.831 40.5162 35.841C40.5162 45.8511 32.4015 53.9658 22.3914 53.9658C12.3814 53.9658 4.2666 45.8511 4.2666 35.841C4.2666 25.831 12.3814 17.7162 22.3914 17.7162Z",
    fill: "#80D4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4037 9.75465C29.9285 9.75465 20.593 19.0901 20.593 30.5653C20.593 42.0405 29.9285 51.376 41.4037 51.376C47.9146 51.376 53.9306 48.4128 57.905 43.2458C58.336 42.6848 58.2314 41.8826 57.6704 41.4517C57.1093 41.0208 56.3072 41.1253 55.8762 41.6864C52.3882 46.2176 47.1146 48.8181 41.4037 48.8181C31.3408 48.8181 23.153 40.6304 23.153 30.5674C23.153 20.5045 31.3408 12.3168 41.4037 12.3168C47.4752 12.3168 53.1328 15.3248 56.5376 20.3637C56.9322 20.9504 57.728 21.104 58.3146 20.7072C58.9013 20.3125 59.0549 19.5168 58.6581 18.9301C54.7776 13.185 48.3264 9.75678 41.4016 9.75678L41.4037 9.75465Z",
    fill: "#5A348C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2075 31.6915H10.3147C9.60853 31.6915 9.03467 32.2653 9.03467 32.9715C9.03467 33.6776 9.60853 34.2515 10.3147 34.2515H45.2075C45.9136 34.2515 46.4874 33.6776 46.4874 32.9715C46.4874 32.2653 45.9136 31.6915 45.2075 31.6915Z",
    fill: "#5A348C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2075 24.7921H10.3147C9.60853 24.7921 9.03467 25.3659 9.03467 26.0721C9.03467 26.7782 9.60853 27.3521 10.3147 27.3521H45.2075C45.9136 27.3521 46.4874 26.7782 46.4874 26.0721C46.4874 25.3659 45.9136 24.7921 45.2075 24.7921Z",
    fill: "#5A348C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euro-icon.49c2f4a3506daa84b8563c63cf0e41d3.svg";
export { ForwardRef as ReactComponent };